import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 760;

/** True below the single 760 px breakpoint. SSR / tests default to desktop. */
export function useIsMobile(breakpoint = MOBILE_BREAKPOINT): boolean {
  const q = `(max-width: ${breakpoint - 1}px)`;
  const [m, setM] = useState(() => (typeof matchMedia !== 'undefined' ? matchMedia(q).matches : false));
  useEffect(() => {
    if (typeof matchMedia === 'undefined') return;
    const mq = matchMedia(q);
    const on = () => setM(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [q]);
  return m;
}

/** Ticking UTC clock string (hh:mm:ss). */
export function useClock(intervalMs = 1000): string {
  const fmt = () => {
    const d = new Date();
    const z = (x: number) => String(x).padStart(2, '0');
    return `${z(d.getUTCHours())}:${z(d.getUTCMinutes())}:${z(d.getUTCSeconds())}`;
  };
  const [t, setT] = useState(fmt);
  useEffect(() => {
    const i = setInterval(() => setT(fmt()), intervalMs);
    return () => clearInterval(i);
  }, [intervalMs]);
  return t;
}
